import "./App.css";
import DisplayContainer from "./components/DisplayContainer";
import Header from "./components/Header";

function App() {
  return (
    <div className="app-container">
      <Header />
      <DisplayContainer />
    </div>
  );
}

export default App;
